import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MirrorList from "./components/MirrorList";
import DomainUpdate from "./components/DomainUpdate";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-800 antialiased">
      <Navbar />
      <main>
        <Hero />
        <MirrorList />
        <DomainUpdate />
        <Guide />
        <Faq />
        <About />
      </main>
      <Footer />
      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 transition hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-lg" />
        </button>
      )}
    </div>
  );
}